import React from 'react';
import adConfig from '../config/adConfig';

// Simplified getAdvertisementId - relying on providedAdId mostly
const getAdvertisementIdFromProps = (providedAdId) => {
  // In MPA, the adId should be explicitly passed by the page using the component
  // For fallback or general cases, ensure a default is provided if needed.
  return providedAdId || adConfig.adIds.defaultAd; // Ensure defaultAd is defined in your adConfig
};

const Advertisement = ({ className = '', adId: providedAdId = null }) => {
  // The adSlotId is determined by the props passed from the page component.
  const adSlotId = getAdvertisementIdFromProps(providedAdId);

  // No more internal state for loading/error/fill attempts related to a custom fillAdSlot call.
  // The SDK loaded via MainLayout is expected to find and fill this div.

  return (
    <div className={`flex justify-center ${className}`}>
      <div className="overflow-hidden flex flex-col rounded-lg border border-gray-200 shadow-sm bg-gray-50">
        {/* Ad Content Div - The SDK will find this by its ID */}
        <div
          id={adSlotId} 
          className="min-w-[300px] min-h-[250px] flex items-center justify-center text-gray-400 text-sm"
        >
          {/* Basic placeholder. SDK will replace this content. */}
          Ad Slot: {adSlotId}
        </div>
      </div>
    </div>
  );
};

export default Advertisement; 